interface CustomerContactDetailsProps {
  fullAddress?: string | null;
  contactName?: string | null;
  contactEmail?: string | null;
  contactNumber?: string | null;
}

function ContactField({
  label,
  value,
  className,
}: {
  label: string;
  value: string;
  className?: string;
}) {
  return (
    <div className={className}>
      <p className='text-sm font-semibold text-gray-900 break-words'>
        {value || '-'}
      </p>
      <p className='text-xs text-gray-400'>{label}</p>
    </div>
  );
}

export function CustomerContactDetails({
  fullAddress,
  contactName,
  contactEmail,
  contactNumber,
}: CustomerContactDetailsProps) {
  const hasAnyContactDetail = !!(
    fullAddress ||
    contactName ||
    contactEmail ||
    contactNumber
  );
  if (!hasAnyContactDetail) return null;

  return (
    <div className='bg-gray-50 rounded-lg p-4 mb-6'>
      <p className='text-[11px] font-medium text-gray-400 uppercase tracking-wider mb-4'>
        Customer Details
      </p>

      <div className='grid grid-cols-2 gap-x-4 gap-y-3'>
        <ContactField
          label='Address'
          value={fullAddress ?? ''}
          className='col-span-2'
        />
        <ContactField label='Contact' value={contactName ?? ''} />
        <ContactField label='Phone' value={contactNumber ?? ''} />
        <ContactField
          label='Email'
          value={contactEmail ?? ''}
          className='col-span-2'
        />
      </div>
    </div>
  );
}
